module.exports = __webpack_public_path__ + "static/img/logo.4fb28ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/district/assets/image/logo.png
// module id = NKlB
// module chunks = 3